module.exports = __webpack_public_path__ + "img/imgmaoxzt-3.624828cb.png";